import { Box, Button, CircularProgress, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactNode } from 'react';

type PinnacleDrawerProps = {
    title: string;
    isDrawerOpen: boolean;
    onClose: () => void;
    children?: ReactNode;
    anchor?: 'left' | 'right' | 'top' | 'bottom';
    customWidthSize?: number;
    onSubmit?: () => void;
    onSubmitName?: string;
    isSubmitting?: boolean;
};

const PinnacleDrawer: React.FC<PinnacleDrawerProps> = (props) => {
    const { title, children, isDrawerOpen, onClose, anchor = 'right', customWidthSize, onSubmit, onSubmitName } = props;
    return (
        <Drawer
            anchor={anchor}
            open={isDrawerOpen}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        width: {
                            xs: '100%',
                            sm: customWidthSize ?? 500,
                        },
                        display: "flex",
                        flexDirection: "column",
                    },
                },
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 2,
                    mx: 2,
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            >
                <Typography variant="h3">{title}</Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Body */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    p: 2,
                    mx: 2,
                    mt: 1.5,
                    overflowY: "auto",
                }}
            >
                {children}
            </Box>

            {/* Footer / Submit button */}
            {onSubmitName && (
                <Box
                    sx={{
                        p: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={onSubmit}
                        disabled={props.isSubmitting}
                    >
                        {props.isSubmitting ? <CircularProgress size={24} color="inherit" /> : onSubmitName}
                    </Button>
                </Box>
            )}
        </Drawer>
    );
};

export default PinnacleDrawer;
